import { Checkbox, Text } from '@chakra-ui/react';
import React from 'react';

interface ICustomCheckBoxProps {
	label: string;
	value: boolean;
	handleChange: () => void;
}

export const CustomCheckBox = ({ label, value, handleChange }: ICustomCheckBoxProps) => {
	return (
		<Checkbox isChecked={value} onChange={handleChange}>
			<Text as="span" fontSize="sm">
				{label}
			</Text>
		</Checkbox>
	);
};
